export const ClickSquareIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 21 20"
      fill="none"
      className={className}
    >
      <path
        d="M18.0013 6.26699V11.167C18.0013 11.4503 17.7263 11.6503 17.4596 11.567L14.1846 10.5503C13.2846 10.2753 12.318 10.5087 11.6596 11.167C10.993 11.8337 10.7513 12.8087 11.0346 13.7087L12.043 16.9587C12.1263 17.2253 11.9263 17.5003 11.643 17.5003H6.76797C3.89297 17.5003 2.16797 15.7837 2.16797 12.9003V6.26699C2.16797 3.38366 3.89297 1.66699 6.76797 1.66699H13.4013C16.2763 1.66699 18.0013 3.38366 18.0013 6.26699Z"
        fill="currentColor"
      />
      <path
        d="M18.8007 15.6997L17.4424 16.1581C17.0674 16.2831 16.7674 16.5747 16.6424 16.9581L16.184 18.3164C15.7924 19.4914 14.1424 19.4664 13.7757 18.2914L12.234 13.3331C11.934 12.3497 12.8424 11.4331 13.8174 11.7414L18.784 13.2831C19.9507 13.6497 19.9674 15.3081 18.8007 15.6997Z"
        fill="currentColor"
      />
    </svg>
  )
}
